import { applyMiddleware, combineReducers, compose,createStore,} from 'redux';
import { thunk } from 'redux-thunk';
import { AuthReducer } from './Reducers/AuthReducer';
import {toggleMenu} from './Reducers/PostsReducer';

const middleware = applyMiddleware(thunk);

const composeEnhancers =
    window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
const reducers = combineReducers({
    sideMenu: toggleMenu,
    auth: AuthReducer	
});

export const store = createStore(reducers,  composeEnhancers(middleware));
